module.exports = __webpack_public_path__ + "1a1612d8f744f4fdabc1027eeb909452.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/pliage_metal_acl.jpg
// module id = 1L4V
// module chunks = 0